const FALLBACK_BASE_URL = "https://inssa.us";

function normalizeBaseUrl(input) {
  const value = String(input || "").trim();
  if (!value) return FALLBACK_BASE_URL;

  try {
    const next = new URL(value);
    return `${next.protocol}//${next.host}`;
  } catch {
    return FALLBACK_BASE_URL;
  }
}

export function getSeoConfig(overrides = {}) {
  const baseUrl = normalizeBaseUrl(overrides.baseUrl || process.env.REACT_APP_BASE_URL);

  return {
    baseUrl,
    siteName: String(overrides.siteName || "Inssa").trim() || "Inssa",
    brandName: String(overrides.brandName || "Inssa").trim() || "Inssa",
    defaultTitle: String(overrides.defaultTitle || "Inssa | Discover Time Capsules Near You").trim(),
    defaultDescription:
      String(
        overrides.defaultDescription ||
          "Discover local time capsules, watch original series, and explore public profiles and businesses on Inssa."
      ).trim(),
    defaultImage: String(overrides.defaultImage || "/inssa_logo512.png").trim() || "/inssa_logo512.png",
    locale: String(overrides.locale || "en_US").trim() || "en_US",
    twitterCard: String(overrides.twitterCard || "summary_large_image").trim() || "summary_large_image",
    twitterSite: String(overrides.twitterSite || "@inssa").trim(),
    googleSiteVerification: String(
      overrides.googleSiteVerification || process.env.REACT_APP_GOOGLE_SITE_VERIFICATION || ""
    ).trim(),
    bingSiteVerification: String(
      overrides.bingSiteVerification || process.env.REACT_APP_BING_SITE_VERIFICATION || ""
    ).trim(),
  };
}

export default getSeoConfig;
